export default {
    computed: {
        tags() {
            if (this.query && this.completions.length > 1) {
                let uniqueTagsArr = this.factoryUniqueTags(this.query);

                if (uniqueTagsArr.length === 1) {
                    const oldTag = uniqueTagsArr[0];
                    const newQuery = this.factoryQuery(this.query , uniqueTagsArr[0]);
                    const newTag = this.factoryUniqueTags(newQuery);

                    if (newTag) {
                        uniqueTagsArr = newTag.map(el => {
                            return oldTag + ' ' + el;
                        });
                    } else {
                        uniqueTagsArr = [oldTag];
                    }
                }
                return uniqueTagsArr;
            }
            return [];
        },
    },
    methods: {
        factoryQuery(query , tag) {
            let result = '';
            query = query.toLowerCase().trim();
            const queryArr = query.split(' ');
            const lastQuery = queryArr.at(-1);

            if (lastQuery !== tag && tag.includes(lastQuery)) {
                queryArr[queryArr.length - 1] = tag;
                result = queryArr.join(' ');
            } else if (!tag.includes(query)) {
                result = query + ' ' + tag;
            }
            return result;
        },
        factoryUniqueTags(query) {
            query = query.toLowerCase().trim();
            const queryArr = query.split(' ');
            const queryArrLastIndex = queryArr.length - 1;
            const firstQuery = queryArr[0];
            const lastQuery = queryArr[queryArrLastIndex];
            let quantityOfHints = 0;
            let tags = this.completions.map(one => {
                const arrText = (one._text) ? one._text.toLowerCase()
                    .split(' ')
                    .map(el => {
                        // eslint-disable-next-line
                        return el.replace(/[^a-zа-яё\d.%,-:#№\\\/]/gi, '')
                            .replace(/,$/gi, '');
                    })
                    .filter(el => el.length) : [];

                const textString = arrText.join(' ');

                if (textString.indexOf(query) === 0) {
                    ++quantityOfHints;
                    if (textString.indexOf(lastQuery) === 0 && arrText[0] !== firstQuery) {
                        return arrText[queryArrLastIndex];
                    } else if (lastQuery !== arrText[queryArrLastIndex]) {
                        return arrText[queryArrLastIndex];
                    } else {
                        return arrText[queryArr.length];
                    }
                }
                return '';
            });

            if (quantityOfHints === 1) {
                tags = [];
            }

            return Array.from(new Set(tags)).filter(el => el);
        },
    },
};